import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import onClickOutside from 'react-onclickoutside'
import TimezoneDatePicker from './event_setup/timezone_date_picker'
import CalendarRoundAdder from './event_setup/calendar_round_adder'
import ClubFeedNotificationDialog, { CONFIRM_MODE } from '../../../shared/components/club_feed_notification_dialog'
import { clubFeedChannelsArmed } from '../../../shared/club_feed_channels'

class InPlaceEditableIncomplete extends Component {
  constructor(props){
    super(props)
    this.state = {
      open: false,
      value: props.value,
    }
    moment.tz.setDefault('Etc/UTC')
  }

  handleClickOutside = (event) => {
    if (this.state.open && event.target.nodeName !== 'INPUT') {
      this.setState({ open: false }, () => event.target.click())
      event.preventDefault()
      this.props.onEditCompleted(this.state.value)
    }
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.setState({ open: false })
      this.props.onEditCompleted(this.state.value)
    }
  }

  render() {
    return (
      this.state.open ?
        <input type='text' value={this.state.value} onChange={e => this.setState({ value: e.target.value})} onKeyPress={this.handleKeyPress} autoFocus />
        :
        <a onClick={() => this.setState({ open: true})}>{this.state.value}</a>
    )
  }
}

InPlaceEditableIncomplete.propTypes = {
  value: PropTypes.string,
  onEditCompleted: PropTypes.func,
}

InPlaceEditableIncomplete.defaultProps = {
  value: '',
  onEditCompleted: () => {},
}

const InPlaceEditable = onClickOutside(InPlaceEditableIncomplete)

class EventSetupRounds extends Component {
  constructor(props){
    super(props)
    this.state = {
      clubFeedPendingRoundId: null,
      clubFeedPendingAction: null,
    }
  }

  requestToggleSignups = (roundId, signupsOpen) => {
    const { club_feed: clubFeed } = this.props.content
    if (clubFeedChannelsArmed(clubFeed && clubFeed.channels)) {
      this.setState({
        clubFeedPendingRoundId: roundId,
        clubFeedPendingAction: signupsOpen ? 'round_signup_closed' : 'round_signup_opened',
      })
    } else {
      this.props.toggleSignups(roundId)
    }
  }

  closeClubFeedConfirm = () => this.setState({ clubFeedPendingRoundId: null, clubFeedPendingAction: null })

  sendClubFeedConfirm = () => {
    const { clubFeedPendingRoundId } = this.state
    this.closeClubFeedConfirm()
    this.props.toggleSignups(clubFeedPendingRoundId)
  }

  skipClubFeedConfirm = () => {
    const { clubFeedPendingRoundId } = this.state
    this.closeClubFeedConfirm()
    this.props.toggleSignups(clubFeedPendingRoundId, true)
  }

  render() {
    const {
      title,
      header,
      rounds,
      lastPossibleDay,
      links,
      enabledDatepicker,
      updatingData,
      club_feed: clubFeed,
    } = this.props.content

    const internationalize = (key) => !window.I18n ? '' : window.I18n.t(key)
    links.update_play_at.path = decodeURI(links.update_play_at.path)

    const hasRounds = rounds.length > 0

    return (
      <div className='widget-content-default widget-event-setup-rounds'>
        <div className='title'>
          {title}
        </div>

        <div className='content'>
          { hasRounds &&
          <div className='rounds_tabular table-responsive'>
            <table className='rounds_table table table-striped'>
              <thead>
                <tr className='header'>
                  {
                    header.map((headerText, index) =>
                      <th key={ `${headerText}-${index}` }>{ headerText }</th>)
                  }
                </tr>
              </thead>

              <tbody>
                {
                  rounds.map((round, idx) =>
                    <tr key={`${round.id}-${round.name}-${round.ggid}`}>
                      <td>
                        <InPlaceEditable
                          value={round.name}
                          onEditCompleted={(name) => name !== round.name && this.props.updateRoundName(round.id, name)}
                        />
                      </td>
                      <td>
                        <label className='font-weight-normal'>{round.ggid}</label>
                      </td>
                      <td className={`datepicker ${enabledDatepicker && enabledDatepicker === round.id ? 'datepicker-open' : ''}`}>
                        {
                          enabledDatepicker && enabledDatepicker === round.id ?
                            <TimezoneDatePicker
                              selected={round.play_at}
                              showTimeSelect={false}
                              targetTimezone='UTC'
                              onCalendarClose={() => this.props.setData([ 'enabledDatepicker' ], false)}
                              onChange={(date) => this.props.updateRoundDate(round.id, date)}
                              onKeyDown={(e) => { e.preventDefault() }}
                              showPopperArrow={false}
                              wrapperClassName='wide-datepicker-input'
                              popperClassName='wide-datepicker'
                              startOpen
                            />
                            :
                            <a onClick={() => this.props.setData([ 'enabledDatepicker' ], round.id)}>
                              <i className='gga-set-up-your-events-date'> </i>
                              {moment
                                  .unix((round.play_at))
                                  .tz('UTC')
                                  .locale(window.I18n.locale === 'en' ? 'en-GB' : window.I18n.locale)
                                  .format(' LL')}
                            </a>
                        }
                      </td>
                      {
                        'signups_open' in round &&
                        <td className='signups'>
                          {
                            round.signups_open.value === 'na' ?
                              <label className='font-weight-normal'> { round.signups_open.labels[round.signups_open.value] } </label>
                            :
                            <label
                              className={ `${ updatingData[round.id] === 'toggleSignups' ? 'loading' : 'toggle'} label label-${round.signups_open.value === 'yes' ? 'success' : 'warning'}` }
                              onClick={ () => this.requestToggleSignups(round.id, round.signups_open.value === 'yes') } >
                              { round.signups_open.labels[round.signups_open.value] }
                            </label>
                          }
                        </td>
                      }
                      <td>
                        <a
                          className={`${ updatingData[round.id] === 'removeRound' ? 'disabled' : ''}`}
                          onClick={() => {
                            const confirmed = window.confirm(internationalize('rounds.tabs.tabs1.remove_round_confirmation'))
                            if (confirmed) {
                              this.props.removeRound(round.id)
                            }
                          }}
                        >
                          {links.remove_round.name}
                        </a>
                      </td>

                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
          }
          {
            hasRounds ?
              <React.Fragment>
                <div className='save-buttons-row'>
                  <a
                    className='save-button'
                    onClick={() => this.props.setData([ 'enabledDatepicker' ], 'AddRounds')}>
                    + {links.add_round.name}
                  </a>
                </div>
                <CalendarRoundAdder
                  popup
                  show={ enabledDatepicker === 'AddRounds' }
                  lastPossibleDay={ lastPossibleDay }
                  adding={ !!updatingData.adding_round }
                  addRounds={ this.props.addRounds }
                  onClose={ () => this.props.setData([ 'enabledDatepicker' ], false) }
                />
              </React.Fragment>
              :
              <CalendarRoundAdder
                lastPossibleDay={ lastPossibleDay }
                adding={ !!updatingData.adding_round }
                addRounds={ this.props.addRounds }
              />
          }
        </div>

        <ClubFeedNotificationDialog
          mode={ CONFIRM_MODE }
          action={ this.state.clubFeedPendingAction }
          show={ this.state.clubFeedPendingRoundId !== null }
          channels={ clubFeed && clubFeed.channels }
          product={ clubFeed && clubFeed.product }
          settingsUrl={ clubFeed && clubFeed.settings_url }
          learnMoreUrl={ clubFeed && clubFeed.learn_more_url }
          onClose={ this.closeClubFeedConfirm }
          onSend={ this.sendClubFeedConfirm }
          onSkip={ this.skipClubFeedConfirm }
        />
      </div>
    )
  }
}

EventSetupRounds.propTypes = {
  content: PropTypes.object,
  setData: PropTypes.func,
  addRounds: PropTypes.func,
  removeRound: PropTypes.func,
  updateRoundDate: PropTypes.func,
  updateRoundName: PropTypes.func,
  toggleSignups: PropTypes.func,
}

EventSetupRounds.defaultProps = {
  content: {
    title: 'ROUNDS',
    header: [],
    rounds: [],
    links: {
      add_round: { name: 'Add rounds', path: '#' },
      remove_round: { name: 'Remove', path: '#' },
      update_play_at: { path: '#' },
      update_round: { path: '#' },
      toggle_signups: { path: '#' },
    },
    enabledDatepicker: false,
    show_widget: true,
  },
}

export default EventSetupRounds
